// Lo puro de la verificación de calidad sobre el lienzo
// (ADR-2026-09-20-la-verificacion-de-calidad-llega-al-lienzo): qué celdas se pueden
// verificar y cuáles cuentan como "de esta sesión" para el análisis automático. La capa
// y el hook son los de la columna de resultados (`pages/v2/verificacion/`); acá sólo se
// arma lo que ese hook pide a partir de las tandas y los nodos del lienzo.

import type { NodoDelLienzo } from './acomodo';
import type { TandaDelLienzo } from './tandasDelLienzo';

/** Los ids de imagen (no video, ya con fila) en el orden del acomodo: lo que la
 *  verificación conoce y sobre lo que cuenta las "malas". */
export function idsVerificables(nodos: readonly NodoDelLienzo[]): string[] {
  const out: string[] = [];
  for (const n of nodos) if (n.data.imageId && !n.data.esVideo) out.push(n.data.imageId);
  return out;
}

/** Las tandas que todavía tienen algún recuadro en vuelo. */
export function tandasEnVuelo(tandas: readonly TandaDelLienzo[]): string[] {
  return tandas.filter((t) => t.celdas.some((c) => c.imageId === null)).map((t) => t.id);
}

/**
 * Las imágenes de las tandas que se vieron volar en ESTA sesión: lo único que el modo
 * automático puede analizar (y pagar). Al volver a un chat viejo, sus fotos no se
 * analizan solas (ADR-2026-09-07-analisis-automatico-al-generar).
 */
export function idsDeTandasDeSesion(
  tandas: readonly TandaDelLienzo[],
  deSesion: ReadonlySet<string>,
): Set<string> {
  const out = new Set<string>();
  for (const t of tandas) {
    if (!deSesion.has(t.id)) continue;
    for (const c of t.celdas) if (c.imageId && !c.esVideo) out.add(c.imageId);
  }
  return out;
}
